// extracted by mini-css-extract-plugin
export default {"container":"_24bb5a71","noReserve":"_15b18157","priceRow":"_892d04f1","boldCopy":"_92b2d4b6","price":"_f7982ffb","priceButton":"_2e56382d","bidDetails":"_4ca1dedb"};